/* Complete KwikPass's truncated order list using Shopify's authenticated app proxy.
 * Existing rows and tracking controls remain owned by KwikPass. No order writes. */
(function () {
  'use strict';
  var active = null;
  function orderId() {
    return /\/pages\/kp-account\/order\/?$/.test(location.pathname) ? new URLSearchParams(location.search).get('id') : null;
  }
  function element(tag, text) {
    var node = document.createElement(tag);
    if (text != null) node.textContent = text;
    return node;
  }
  function row(item) {
    var node = element('div');
    node.style.cssText = 'display:flex;gap:16px;padding:16px 0;border-top:1px solid #eee;align-items:flex-start';
    var imageUrl = item.image && item.image.url;
    if (imageUrl && /^https:\/\//.test(imageUrl)) {
      var image = element('img'); image.src = imageUrl; image.alt = item.title;
      image.width = 80; image.height = 80; image.loading = 'lazy';
      image.style.cssText = 'width:80px;height:80px;object-fit:cover;border-radius:8px;flex-shrink:0';
      node.appendChild(image);
    }
    var copy = element('div'); copy.style.cssText = 'min-width:0;flex:1';
    var title = element('h3'); title.style.cssText = 'font-size:14px;font-weight:500;line-height:1.5;margin:0 0 8px';
    if (item.product && item.product.handle) {
      var link = element('a', item.title);
      link.href = '/products/' + encodeURIComponent(item.product.handle) + (item.variant ? '?variant=' + encodeURIComponent(item.variant.id.split('/').pop()) : '');
      title.appendChild(link);
    } else title.textContent = item.title;
    copy.appendChild(title);
    if (item.variantTitle && item.variantTitle !== 'Default Title') copy.appendChild(element('p', item.variantTitle));
    var money = item.originalTotalSet.shopMoney;
    var price = new Intl.NumberFormat('en-IN', {style:'currency', currency:money.currencyCode}).format(Number(money.amount));
    copy.appendChild(element('p', price + ' · Qty: ' + item.quantity));
    node.appendChild(copy); return node;
  }
  window.ESCompleteAccountItems = function (root) {
    var id = orderId();
    var region = root.querySelector('[data-kp-target="region.order.items"]');
    if (!id || !region) { active = null; return; }
    if (active && active.id === id && active.region === region && active.box.isConnected) return;
    var titles = Array.from(region.querySelectorAll('h3')).map(function (h) { return h.textContent.trim(); });
    if (!titles.length) return;
    var state = active = {id:id, region:region};
    var box = element('div'); box.dataset.esCompleteItems = id;
    box.style.cssText = 'padding:0 16px';
    state.box = box;
    var status = element('p', 'Loading complete item list…');
    status.style.cssText = 'font-size:13px;padding:12px 0'; status.setAttribute('role', 'status');
    box.appendChild(status); region.appendChild(box);
    function current() { return active === state && orderId() === id && region.isConnected; }
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    fetch('/apps/returns/api/portal/order-items?order_id=' + encodeURIComponent(id), {
      credentials:'same-origin', cache:'no-store', signal:controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('items unavailable');
      return response.json();
    }).then(function (data) {
      if (!current()) return;
      if (!data.ok || data.order_id !== id || !Array.isArray(data.items)) throw new Error('wrong order');
      // The vendor fetches the first Shopify page, but may group those rows by shipment.
      // Compare the title multiset of that prefix; fail visibly if its contract changes;
      // do not guess which lines are absent (duplicate products and quantities are valid).
      if (titles.length > data.items.length || JSON.stringify(titles.slice().sort()) !== JSON.stringify(data.items.slice(0, titles.length).map(function (item) { return item.title; }).sort())) throw new Error('item order changed');
      var fragment = document.createDocumentFragment();
      data.items.slice(titles.length).forEach(function (item) { fragment.appendChild(row(item)); });
      status.textContent = 'All ' + data.items.length + ' items';
      box.appendChild(fragment);
    }).catch(function () {
      if (!current()) return;
      status.textContent = 'The complete item list could not load. ';
      var retry = element('button', 'Try again'); retry.type = 'button';
      retry.style.cssText = 'text-decoration:underline;cursor:pointer';
      retry.onclick = function () { box.remove(); active = null; window.ESCompleteAccountItems(root); };
      status.appendChild(retry);
    }).finally(function () { clearTimeout(timeout); });
  };
}());
